module.exports = __webpack_public_path__ + "img/logstcs_economy.mars.3950d9e.png";